import {bufferTime, catchError, distinct, filter, map, mergeMap} from "rxjs/operators";
import {ajax} from 'rxjs/ajax';
import {interval, of} from 'rxjs';
import {combineEpics} from "redux-observable";
import {networkError} from "../actions/ui";
import {addCodes, API_GET_CODE, API_GET_CODES, API_GET_CODES_DONE, getCodeDone} from "../actions/codes";
import {catchErrorsandResume} from "./index";

const requestDedupInterval$ = interval(100);

const getCodesEpic = action$ => action$.pipe(
  filter(action => action.type === API_GET_CODES),
  distinct(action => action.payload.codeType, requestDedupInterval$),
  mergeMap(action => ajax.getJSON(`/codes/${action.payload.codeType}`).pipe(
    map(response => getCodeDone(response)),
    catchError(error => of(networkError({...error, number: '10077-'+error.status+'-'+error.xhr.response})))
  )),
  catchErrorsandResume(20010)
);

const getCodeEpic = action$ => action$.pipe(
  filter(action => action.type === API_GET_CODE),
  mergeMap(action => ajax.getJSON(`/code/${action.payload.codeType}/${action.payload.code}`).pipe(
    map(response => getCodeDone(response)),
    catchError(error => of(networkError({...error, number: '10078-'+error.status+'-'+error.xhr.response})))
  )),
  catchErrorsandResume(20009)
);

const processCodesEpic = action$ => action$.pipe(
  filter(action => action.type === API_GET_CODES_DONE),
  map(action => action.payload),
  bufferTime(300),
  filter(results => results.length > 0),
  map(results => {
    if (!Array.isArray(results)) {
      results = [results];
    }
    addCodes(results);
  }),
  catchErrorsandResume(20011)
);

export const codesEpic = combineEpics(
  getCodesEpic,
  getCodeEpic,
  processCodesEpic
);



// WEBPACK FOOTER //
// ./src/network/codes.js